<template>
  <div class="intro-root">
    <div class="bird"></div>
    <div class="skip-btn" @click="skip()">跳 过</div>
    <div class="tree"></div>
    <div class="text-container">
      <img v-for="(item, index) in textImgs" :key="index" :src="item.src" class="text-item" :style="{opacity:textimgOpacity,transition:'opacity 1.2s '+(index*1.2+1.5)+'s ease'}"></img>
    </div>
    <div class="cloud-left"></div>
    <div class="cloud-right"></div>
    <div class="btn" @click="openLetter()" :style="{opacity:textimgOpacity,transition:'opacity .8s '+8.5+'s ease'}"></div>
  </div>
</template>

<script>

export default {
  name: 'Input',
  data () {
    return {
      textImgs:[
        {
          src: require('../assets/intro/1.png')
        },
        {
          src: require('../assets/intro/2.png')
        },
        {
          src: require('../assets/intro/3.png')
        },
        {
          src: require('../assets/intro/4.png')
        },
        {
          src: require('../assets/intro/5.png')
        },
        {
          src: require('../assets/intro/6.png')
        },
        {
          src: require('../assets/intro/7.png')
        }
      ],
      textimgOpacity: 0,
      timer1: null,
      timer2 : null
    }
  },
  mounted() {
    this.timer1 = setTimeout(() =>{
      this.textimgOpacity = 1
    },0)
    this.timer2 = setTimeout(() => this.openLetter = () => {
      const name = this.$route.query.name || '你'
      const random = this.$route.query.article
      this.$router.push(`/result?name=${name}&article=${random}`)
    },9000)
  },
  methods: {
    openLetter() {
    },
    skip() {
      clearTimeout(this.timer2)
      const name2 = this.$route.query.name || '你'
      const random2 = this.$route.query.article
      this.$router.push(`/result?name=${name2}&article=${random2}`)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped >
.intro-root{
  width: 100%;
  height: 100%;
  position: relative;
  background: url("../assets/intro/bg.jpg") center no-repeat;
  background-size: cover;
  box-sizing: border-box;
  overflow: hidden;
  animation: zoomIn .5s ease-in-out;
}
.skip-btn{
  position: absolute;
  font-size: 3rem;
  width: 8rem;
  height: 4rem;
  top:3rem;
  right:2rem;

}
  .bird{
    position: absolute;
    width:15vw;
    height: 15vw;
    top:5rem;
    left:0;
    opacity: 0;
    background: url("../assets/intro/bird.gif") center no-repeat;
    background-size: cover;
    animation: birdFly 5s 0.5s infinite linear;
  }
.tree{
  position: absolute;
  width: 65.16vw;
  height: 24.6vw;
  top: 12%;
  right:0;
  background: url("../assets/intro/tree.png") center no-repeat;
  background-size: cover;
  animation: treeMove 8s 0.5s infinite ease-in-out;
}
.cloud-right{
  position: absolute;
  width:40.6vw;
  height: 18.8vw;
  bottom: 10%;
  right:0;
  background: url("../assets/intro/cloud_right.png") center no-repeat;
  background-size: cover;
  animation: moveToLeft 10s infinite ease-in-out;
}
.cloud-left{
  position: absolute;
  width:24.84vw;
  height: 34.92vw;
  bottom:17%;
  left:0;
  background: url("../assets/intro/cloud_left.png") center no-repeat;
  background-size: cover;
  animation: moveToRight 10s infinite ease-in-out;
}
.text-container{
  position: absolute;
  top:50%;
  left:50%;
  width: 54.06vw;
  transform: translate(-50%,-50%);
  display: flex;
  flex-direction: column;
}
  .text-item{
    width: 54.06vw;
    height: 7.14vw;
    margin: .1rem 0;
  }
  .btn{
    position: absolute;
    background: url("../assets/intro/btn.png") center no-repeat;
    background-size: cover;
    width: 36vw;
    height: 13.5vw;
    bottom: 12%;
    left:50%;
    transform: translateX(-50%);
  }
@keyframes moveToLeft {
    0%{
      transform: translateX(0);
    }
    50%{
      transform: translateX(50%);
    }
    100%{
      transform: translateX(0);
    }
  }
@keyframes moveToRight {
  0%{
    transform: translateX(0);
  }
  50%{
    transform: translateX(-50%);
  }
  100%{
    transform: translateX(0);
  }
}
@keyframes treeMove {
  0%{
    transform:  rotate(0deg);
  }
  50%{
    transform:  rotate(5deg);
    transform-origin: right top;
  }
  100%{
    transform:  rotate(0deg);
  }
}
@keyframes birdFly {
  0%{
    opacity: 0;
    left:0;
  }
  25%{
    opacity: 1;
    top: 9rem;
    left: 25%;
  }
  50%{
    left: 50%;
  }
  75%{
   top:5rem;
    opacity: 1;
    left:75%;
  }
  100%{
    opacity: 0;
    left:100%;
  }
}

@keyframes zoomIn {
  from {
    opacity: 0.5;
  }

  100%{
    opacity: 1;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/Intro.vue